export default "__VITE_ASSET__Ct4Jv_7D__"